export default {
  metadata: {
    version: '1.0.0',
    id: 'tooltip-1.0.0',
    name: 'JDSTooltip',
    description:
      'Tooltips are floating elements primarily used for accessibility as its function. It is used to display additional information about a user interface element or feature.',
    usage:
      'The information included should be contextual, helpful, and nonessential while providing that extra ability to communicate and give clarity to a user.'
  },
  hierarchy: {
    popup: [
      {
        'popup-container': ['jds_tooltip_internal']
      }
    ]
  },
  base: {
    popup: {
      passive: true,
      hidden: true,
      priority: 30
    },
    'popup-container': {
      'flex-direction': '{t_0}',
      'justify-content': '{t_1}',
      'align-items': '{t_2}'
    },
    jds_tooltip_internal: {}
  },
  variant: {
    position: {
      right_start: {
        jds_tooltip_internal: {
          position: 'right_start'
        }
      },
      right_end: {
        jds_tooltip_internal: {
          position: 'right_end'
        }
      },
      left: {
        jds_tooltip_internal: {
          position: 'left'
        }
      },
      left_start: {
        jds_tooltip_internal: {
          position: 'left_start'
        }
      },
      left_end: {
        jds_tooltip_internal: {
          position: 'left_end'
        }
      },
      top: {
        jds_tooltip_internal: {
          position: 'top'
        }
      },
      top_start: {
        jds_tooltip_internal: {
          position: 'top_start'
        }
      },
      top_end: {
        jds_tooltip_internal: {
          position: 'top_end'
        }
      },
      bottom: {
        jds_tooltip_internal: {
          position: 'bottom'
        }
      },
      bottom_start: {
        jds_tooltip_internal: {
          position: 'bottom_start'
        }
      },
      bottom_end: {
        jds_tooltip_internal: {
          position: 'bottom_end'
        }
      }
    },
    open: {
      true: {
        popup: {
          hidden: false
        }
      }
    },
    _platform: {
      desktop: {
        jds_tooltip_internal: {
          _platform: 'desktop'
        }
      }
    }
  },
  api: {
    config: {
      position: {
        values: [
          'right',
          'right_start',
          'right_end',
          'bottom',
          'bottom_start',
          'bottom_end',
          'left',
          'left_start',
          'left_end',
          'top',
          'top_start',
          'top_end'
        ],
        'doc-description':
          'It can be used to give certain position to the Tooltip.'
      },
      open: {
        values: [false, true],
        doc_description:
          'It can be used to progamtically open and close Tooltip.'
      },
      _platform: {
        values: ['mobile', 'desktop']
      }
    },
    data: {
      jds_tooltip_internal: {
        label: {
          type: 'string',
          name: 'label',
          doc_description: 'It displays label of Tooltip.'
        },
        triggerRef: {
          type: 'ref',
          name: 'triggerRef'
        },
        width: {
          type: 'size',
          name: 'width'
        },
        triggerSpacing: {
          type: 'size',
          name: 'triggerSpacing',
          function: true
        }
      },
      'popup-container': {
        'padding-left': {
          type: 'size',
          name: 'offsetX'
        },
        'padding-top': {
          type: 'size',
          name: 'offsetY'
        }
      }
    },
    events: {
      jds_tooltip_internal: {
        onAppear: {
          name: '_onAppear',
          platform: 'ios'
        },
        onTextLayout: {
          name: 'onTextLayout',
          platform: 'android'
        }
      },
      popup: {
        onHover: {
          name: 'onHover',
          platform: 'web'
        }
      }
    },
    a11y: {
      jds_tooltip_internal: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
